module.exports = __webpack_public_path__ + "static/media/tutorial_text.4a7c702c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/tutorial_text.svg
// module id = 186
// module chunks = 6